import React from 'react';
import SearchInput from '../Common/SearchInput';
import './Searchbar.css'
import { useTranslation } from 'react-i18next';

const SearchBar = () => {
    const { t } = useTranslation();

    return ( 
        <div className='SearchBar'> 
            <SearchInput 
                Label={t('search.labelEvent')} 
                InputType="text" 
                Placeholder={t('search.placeholderEvent')} 
            />
            <SearchInput 
                Label={t('search.labelPlace')} 
                InputType='text' 
                Placeholder={t('search.placeholderPlace')} 
            />
            <SearchInput 
                Label={t('search.labelTime')} 
                InputType='date' 
            />
        </div>
     );
}
 
export default SearchBar;